import { getAS2MessageEndpoint, updateAS2MessageEndpoint } from './HrpsCertificatesApi';
import {
    addAttachmentToClaim,
    getClaimUploadTemplates,
    getClaimDocumentUrl,
    generateClaimTemplate,
    getClaimByResellerClaimNumber,
    processClaimUpload,
    processPdfClaimUpload,
    removeAttachmentFromClaim,
    requestClaimUploadUrl,
} from './HrpsClaimsApi';
import { calculateContractTermsCompliance } from './HrpsContractTermsApi';
import {
    createSalesOrder,
    getPurchaseOrderExtractionDraft,
    requestDocumentUploadUrl,
    startDocumentExtraction,
} from './HrpsExtractionsApi';
import { addCorrespondence, createIssue, getIssues } from './HrpsIssuesApi';
import { addLocation, editLocation } from './HrpsLocationsApi';
import { getOfflinePromotions } from './HrpsPromotionsApi';
import { getResellerAssortedFamilies, getResellerReturnTimeWindows } from './HrpsResellerApi';
import {
    createReturnOrderDraft,
    deleteReturnOrderDraft,
    getReturnOrderDocuments,
    getSalesOrderDocuments,
    submitReturnOrder,
    getReturnOrderProblemShelf,
    updateReturnOrderDraft,
    requestAttachmentUploadUrl,
    requestReturnOrderUploadUrl,
    processReturnOrderUpload,
    getReturnOrderUploadTemplates,
    deleteAttachments,
    getCreditMemoContent,
} from './HrpsReturnOrdersApi';
import {
    addUserTermsAndConditionsAcceptanceApi,
    getUserTermsAndConditionsAcceptancesApi,
} from './HrpsUserTermsAndConditionsApi';

export const useHrpsApi = () => {
    return {
        returnOrders: {
            getReturnOrderDocuments,
            getSalesOrderDocuments,
            createReturnOrderDraft,
            deleteReturnOrderDraft,
            submitReturnOrder,
            getReturnOrderProblemShelf,
            updateReturnOrderDraft,
            requestReturnOrderUploadUrl,
            processReturnOrderUpload,
            getReturnOrderUploadTemplates,
            requestAttachmentUploadUrl,
            deleteAttachments,
            getCreditMemoContent,
        },
        claims: {
            addAttachmentToClaim,
            getClaimDocumentUrl,
            getClaimUploadTemplates,
            getClaimByResellerClaimNumber,
            generateClaimTemplate,
            processClaimUpload,
            processPdfClaimUpload,
            removeAttachmentFromClaim,
            requestClaimUploadUrl,
        },
        certificates: {
            getAS2MessageEndpoint,
            updateAS2MessageEndpoint,
        },
        contractTerms: {
            calculateContractTermsCompliance,
        },
        extractions: {
            createSalesOrder,
            getPurchaseOrderExtractionDraft,
            requestDocumentUploadUrl,
            startDocumentExtraction,
        },
        locations: {
            addLocation,
            editLocation,
        },
        issues: {
            getIssues,
            createIssue,
            addCorrespondence,
        },
        promotions: {
            getOfflinePromotions,
        },
        reseller: {
            getResellerReturnTimeWindows,
            getResellerAssortedFamilies,
        },
        termsAndConditions: {
            addUserTermsAndConditionsAcceptanceApi,
            getUserTermsAndConditionsAcceptancesApi,
        },
    };
};
